/**
 * Extension interface to extend the types of the columnDefinition from the tanstack table.
 * @public
 */
export interface DataTableV2AlignmentColumnDef {
  /** Defines the text alignment inside the column cell. */
  alignment?: 'left' | 'center' | 'right';
}

/** @internal */
export const DATA_TABLE_V2_DEFAULT_HORIZONTAL_ALIGNMENT: Required<DataTableV2AlignmentColumnDef>['alignment'] =
  'left';
